import { io } from 'socket.io-client';

let shared = null;
let lastJoin = { roomId: 'HOME', role: 'scoreboard' };

function emitJoin(socket) {
  if (!socket || !lastJoin.roomId) return;
  socket.emit('room:join', { roomId: lastJoin.roomId, role: lastJoin.role });
}

export function getSocket() {
  if (shared) return shared;
  shared = io({
    path: '/socket.io',
    transports: ['websocket', 'polling'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 600,
    reconnectionDelayMax: 4000,
    timeout: 10000,
  });
  shared.on('connect', () => emitJoin(shared));
  shared.io.on('reconnect', () => emitJoin(shared));
  return shared;
}

export function joinRoom(roomId, role) {
  const s = getSocket();
  lastJoin = { roomId: String(roomId || 'HOME').toUpperCase(), role: role || 'scoreboard' };
  if (s.connected) {
    emitJoin(s);
  } else {
    s.connect();
  }
  return s;
}

export function socketConnected() {
  return !!(shared && shared.connected);
}
